// extracted by mini-css-extract-plugin
export default {"goalHierarchyForm":"GoalHierarchyForm_goalHierarchyForm__SXhQZ"};